import React, { Component } from "react";
import { documentsTitles, saved, remote } from "./dynamic_documents";

export class CollectSanctionLetter extends Component {
  saved(key) {
    return saved(this, key);
  }

  remote(key) {
    return remote(this, key);
  }

  genFields(letterIndex = 0, loanIndex = 0) {
    return [
      {
        label: "No of Loans",
        name: "no_of_loans",
        type: "text",
      },
      {
        label: "Loan Type",
        name: "loan_type",
        type: "select",
        options: enums.LoanTypes,
        required: true,
      },
      {
        label: "Account Number",
        name: "account_number",
        type: "text",
        required: true,
      },
      {
        label: "Sanction Amount",
        name: "sanction_amt",
        type: "number",
        required: true,
      },
      {
        label: "Outstanding Amount",
        name: "outstanding_amt",
        type: "number",
        required: true,
      },
      {
        label:
          this.saved(`letters.${letterIndex}.loans.${loanIndex}.loan_type`) ==
          "CC/OD"
            ? "Intrest Amount"
            : "EMI Amount",
        name: "emi_amt",
        type: "number",
        required: true,
      },
      {
        label: "Frequency",
        name: "frequency",
        type: "select",
        options: enums.LoanPaymentFrequency,
        required: true,
      },
      {
        label: "Start Date",
        name: "loan_state_date",
        type: "date",
        required: true,
      },
      {
        label: "End Date",
        name: "loan_end_date",
        type: "date",
        required: true,
      },
    ];
  }

  genLetter(index = 0) {
    let loans = this.saved(`letters.${index}.loans`) || [];
    return {
      label: "Upload Sanction Letter",
      defname: "sanction_letter_file",
      outClassName: "col-md-8",
      type: "fileuploader",
      intype: "filepassword",
      required: true,
      name: `letters.{i}.{name}`,
      uploadpayload: {
        application_id: `{application_id}`,
        doc_meta_name: {
          name: `letters.{i}.{name}`,
          group: "credit",
          documentKey: `{documentKey}`,
        },
      },
      loans: loans.length
        ? loans.map((o, j) => this.genFields(index, j))
        : [this.genFields(index)],
    };
  }

  constructor(props) {
    super(props);
    props.initialconstruct.bind(this)("CollectSanctionLetter");
    let letters = this.saved("letters") || [];
    this.state = {
      letters: letters.length
        ? letters.map((o, i) => this.genLetter(i))
        : [this.genLetter()],
    };
  }

  setLetters(pletters) {
    let letters = structuredClone(pletters);
    let storeletters = letters.map((latter, i) => {
      latter.loans = latter.loans.map((loan, j) => {
        let remotel =
          app.props.store.credit.remote[this.props.documentKey]?.letters[i]
            ?.loans[j] || {};
        let saved = this.saved(`letters.${i}.loans.${i}`) || {};
        return loan.reduce(
          (o, n) => ({
            ...o,
            [n.name]: remotel[n.name] || saved[n.name] || "",
          }),
          {
            ...remotel,
          }
        );
      });
      return latter;
    });
    this.store(`credit.state.${this.props.documentKey}.letters`, storeletters);
  }

  addLetter() {
    let letters = this.state.letters;
    letters.push(this.genLetter(letters.length + 1));
    this.setState({
      letters,
    });
    this.setLetters(letters);
  }

  deleteFile(attachment_id) {
    return new Promise((resolve, reject) => {
      app.api
        .execApi("deleteDocument", {}, { attachment_id })
        .then(() => {
          this.props.onFetchDocList && this.props.onFetchDocList();
          resolve();
        })
        .catch(resolve);
    });
  }

  async deleteLetter(letter, index) {
    let deleteLocal = () => {
      let letters = this.state.letters;
      letters = letters.filter((v, i) => i != index);
      this.setState({
        letters,
      });
      this.setLetters(letters);
    };
    let formData = this.refs.form.form.current.getData();
    let payload = parseInput(formData).letters[index];
    console.log(payload);
    let sanction_letter_id = letter?.sanction_letter_id || "";
    if (sanction_letter_id) {
      this.api
        .execApi(
          "deleteSanctionLetter",
          {},
          {
            sanction_letter_id,
          }
        )
        .then(async () => {
          if (payload?.sanction_letter_file?.attachment_id) {
            await this.deleteFile(payload?.sanction_letter_file?.attachment_id);
          }
          deleteLocal();
          this.props.onInfoList && this.props.onInfoList();
        });
    } else {
      if (payload?.sanction_letter_file?.attachment_id) {
        await this.deleteFile(payload?.sanction_letter_file?.attachment_id);
      }
      deleteLocal();
    }
  }

  addLoan(i) {
    let letters = this.state.letters;
    let loans = letters[i].loans;
    loans.push(this.genFields(letters.length + 1, loans.length + 1));
    this.setLetters(letters);
    this.setState({
      letters,
    });
    console.log({ letters });
  }

  deleteLoan(loan_sanctioned_id, i, index) {
    const deleteLocal = () => {
      let letters = this.state.letters;
      let loans = letters[i].loans;
      letters[i].loans = loans.filter((v, j) => j != index);
      this.setState({
        letters,
      });
      console.log({ letters });
      this.setLetters(letters);
    };
    if (loan_sanctioned_id) {
      let sanction_letter_id = this.remote(`letters.${i}.sanction_letter_id`);
      this.api
        .execApi(
          "deleteLoanSanctionLetter",
          {},
          {
            loan_sanctioned_id,
            sanction_letter_id,
          }
        )
        .then(() => {
          deleteLocal();
          this.props.onInfoList && this.props.onInfoList();
        });
    } else {
      deleteLocal();
    }
  }

  handleInputEvent(args, key, payload) {
    console.log({ ...args, key, payload });
    let { field, i, j } = payload;
    let [e, date] = args;
    field.onChange && field.onChange(this, payload, ...args);
    if (field.type == "select") {
      return this.handleSelectEvent(e, key, field);
    } else if (field.type == "date") {
      return this.setStateValue(key, date);
    }
    mixins.debounce(() => {
      this.setStateValue(key, e.target.value);
      setTimeout(() => {
        let input = document.querySelector(`[name='${e.target.name}']`);
        input && input.focus();
      }, 0);
    });
  }

  handleSelectEvent([value], key) {
    this.setStateValue(key, value.key);
  }

  setStateValue(key, value) {
    console.log(`${this.props.documentKey}.${key}`, key);
    this.store(`credit.state.${this.props.documentKey}.${key}`, value);
  }

  saveInfo(form, data) {
    let parseddata = parseInput(data);
    let payload = parseddata.letters.map((letter) => ({
      sanction_letter_id: letter.sanction_letter_file.sanction_letter_id || "",
      attachment_id: letter.sanction_letter_file.attachment_id,
      filename: letter.sanction_letter_file.filename,
      ...(letter.sanction_letter_file.password
        ? { password: letter.sanction_letter_file.password }
        : {}),
    }));
    let letters = this.saved("letters") || [];
    let sactionpromise = [];
    let putArr = payload.filter((o) => o.sanction_letter_id);
    let postArr = payload.filter((o) => !o.sanction_letter_id);
    if (postArr.length) {
      let postPayload = postArr.map((o) =>
        Object.except(o, ["sanction_letter_id"])
      );
      let postpromise = this.api.execApi("postSanctionLetter", postPayload);
      sactionpromise.push(postpromise);
    }
    if (putArr.length) {
      let tmpsactionpromise = putArr.map((item) =>
        this.api.execApi(
          "putSanctionLetter",
          Object.except(item, ["sanction_letter_id"]),
          {
            sanction_letter_id: item.sanction_letter_id,
          }
        )
      );
      sactionpromise = sactionpromise.concat(tmpsactionpromise);
    }
    Promise.all(sactionpromise).then((responses) => {
      let items = responses.reduce(
        (c, v) => (v.data.items ? c.concat(v.data.items) : [...c, v.data]),
        []
      );
      console.log({ items });
      let promises = [];
      parseddata.letters.map((letter) => {
        let attachment_id = letter.sanction_letter_file.attachment_id;
        let sanction_letter = items.find(
          (o) => o.attachment_id == attachment_id
        );
        let sanction_letter_id = sanction_letter?.sanction_letter_id || "";
        let loanpayload = letter.loans.map((loan) => ({
          loan_sanctioned_id: loan.loan_sanctioned_id,
          loan_type: loan.loan_type,
          account_number: loan.account_number,
          sanction_amt: loan.sanction_amt,
          outstanding_amt: loan.outstanding_amt,
          emi_amt: loan.emi_amt,
          frequency: loan.frequency,
          loan_state_date: loan.loan_state_date,
          loan_end_date: loan.loan_end_date,
        }));
        let savedloans = loanpayload.filter((o) => o.loan_sanctioned_id);
        let newloans = loanpayload
          .filter((o) => !o.loan_sanctioned_id)
          .map((loan) => Object.except(loan, ["loan_sanctioned_id"]));
        console.log({
          savedloans,
          loanpayload,
          sanction_letter_id,
          letters,
          attachment_id,
          parseddata,
        });
        if (savedloans.length) {
          let tmppromises = savedloans.map((loanPayload, i) => {
            let savedloan = savedloans[i];
            return this.api.execApi(
              "putLoanSanctionLetter",
              Object.except(loanPayload, ["loan_sanctioned_id"]),
              {
                loan_sanctioned_id: savedloan.loan_sanctioned_id,
                sanction_letter_id,
              }
            );
          });
          promises = promises.concat(tmppromises);
        }
        if (newloans.length) {
          let loanpromise = this.api.execApi(
            "postLoanSanctionLetter",
            newloans,
            {
              sanction_letter_id,
            }
          );
          promises.push(loanpromise);
        }
        return promises;
      });
      Promise.all(promises).then((respose) => {
        alert("Info Updated Successfull.").promise.then(() => {
          this.props.onInfoList && this.props.onInfoList();
        });
      });
    });
  }

  render() {
    let { props, state } = this;
    let { letters } = state;
    return (
      <AppForm onSubmit={(...args) => this.saveInfo(...args)} ref={"form"}>
        {letters.map((letter, i) => (
          <div className="row" key={"row" + i}>
            <div className="col-12 flex">
              <input
                name={`letters.${i}.sanction_letter_file.sanction_letter_id`}
                type="hidden"
                value={this.remote(`letters.${i}.sanction_letter_id`)}
              ></input>
              {i != 0 && (
                <button
                  type="button"
                  className="btn text-red-500 ml-auto"
                  onClick={() =>
                    this.deleteLetter(this.remote(`letters.${i}`), i)
                  }
                >
                  Delete Letter <i className="fa fa-trash" />
                </button>
              )}
            </div>
            <div className="col-12">
              <AppInput
                {...templateObject(
                  Object.except(letter, ["outClassName", "loans"]),
                  {
                    i,
                    documentKey: props.documentKey,
                    name: letter.defname,
                  }
                )}
              />
            </div>
            <div className="col-12">
              <div className="row">
                <div className="col-12">
                  {letter.loans.map((fields, j) => (
                    <div className="row" key={"col" + j}>
                      <input
                        type="hidden"
                        name={`letters.${i}.loans.${j}.loan_sanctioned_id`}
                        value={this.remote(
                          `letters.${i}.loans.${j}.loan_sanctioned_id`
                        )}
                      ></input>
                      <div className="col-12 flex">
                        {j != 0 && (
                          <button
                            type="button"
                            className="btn text-red-500 ml-auto"
                            onClick={() =>
                              this.deleteLoan(
                                this.remote(
                                  `letters.${i}.loans.${j}.loan_sanctioned_id`
                                ),
                                i,
                                j
                              )
                            }
                          >
                            Delete Loan <i className="fa fa-trash" />
                          </button>
                        )}
                      </div>
                      {fields.map((obj) => (
                        <div
                          key={obj.name}
                          className={Object.className({
                            "col-12": true,
                            [obj.outClassName || "col-md-4"]: true,
                          })}
                        >
                          <AppInput
                            {...Object.except(obj, ["outClassName"])}
                            name={`letters.${i}.loans.${j}.${obj.name}`}
                            onChange={(...args) =>
                              this.handleInputEvent(
                                args,
                                `letters.${i}.loans.${j}.${obj.name}`,
                                { field: obj, i, j }
                              )
                            }
                            defaultValue={this.saved(
                              `letters.${i}.loans.${j}.${obj.name}`
                            )}
                          />
                        </div>
                      ))}
                      <hr />
                    </div>
                  ))}
                </div>
                <div className="col-12">
                  <button
                    className="btn ml-auto text-primary"
                    type="button"
                    onClick={() => this.addLoan(i)}
                  >
                    <i className="fa fa-plus" /> Add Loan
                  </button>
                </div>
              </div>
            </div>
            <hr />
          </div>
        ))}
        <div className="row d-flex mb-3 g-3">
          <div className="col-12">
            <button
              className="btn add-btn ml-auto"
              type="button"
              onClick={() => this.addLetter()}
            >
              <i className="fa fa-plus" /> Add Sanction Letter
            </button>
          </div>
        </div>
        <div className="row d-flex">
          <div>
            <button className="btn add-btn text-dark rounded-pill ml-auto">
              Update
            </button>
          </div>
        </div>
        <hr />
      </AppForm>
    );
  }
}

export default connect(CollectSanctionLetter);
